// UNIXORN — Shopify Storefront mapping (Path A: redirect checkout)
// All commerce lives on Shopify. The cinematic site is the brand experience.
// Each product CTA opens the matching Shopify product or collection page.

export const SHOPIFY_DOMAIN = "https://shop.unixornworldwide.com";

// Cream Monochrome Collection — live Shopify products
export const SHOPIFY_HANDLES = {
  "embossed-cream-unixorn-set": "embossed-cream-unixorn-set",
  "cream-hoodie": "cream-hoodie",
  "embossed-cream-unixorn-sweatpants": "embossed-cream-unixorn-sweatpants",
  "signature-statement-tee": "signature-statement-tee",
  "sigil-tee": "sigil-tee",
  "saint-tee": "saint-tee",
  "essentials-tee": "essentials-tee",
  "unixorn-relic-bucket-hat": "unixorn-relic-bucket-hat",
  "sigil-cap-copy": "sigil-cap-copy", // Cream Sigil Beanie
  "unixorn-celestial-cream-low": "unixorn-celestial-cream-low", // First luxury footwear release
};

// Collection slugs that live on Shopify
export const SHOPIFY_COLLECTIONS = {
  crowns: "fitteds",
  classics: "classics",
  tracksuits: "tracksuits-1",
  tshirts: "t-shirts",
  footwear: "footwear",
  all: "all",
};

/**
 * Returns the customer-facing Shopify product URL for a given internal id.
 * Returns null if the product is not stocked on Shopify (e.g. concept items).
 */
export const getShopifyProductUrl = (id) => {
  const handle = SHOPIFY_HANDLES[id];
  if (!handle) return null;
  return `${SHOPIFY_DOMAIN}/products/${handle}`;
};

/**
 * Returns the Shopify collection URL by key (e.g. 'crowns', 'classics').
 */
export const getShopifyCollectionUrl = (key) => {
  const slug = SHOPIFY_COLLECTIONS[key];
  if (!slug) return SHOPIFY_DOMAIN;
  return `${SHOPIFY_DOMAIN}/collections/${slug}`;
};

/**
 * True if the product is currently sold on Shopify.
 */
export const isPurchasable = (id) => Boolean(SHOPIFY_HANDLES[id]);

/**
 * Redirects the current tab to the matching Shopify product page.
 * Falls back to the Shopify domain root if id is unknown.
 */
export const goToShopify = (id) => {
  const url = getShopifyProductUrl(id) || SHOPIFY_DOMAIN;
  window.location.href = url;
};

/**
 * Redirects the current tab to a Shopify collection.
 */
export const goToShopifyCollection = (key) => {
  window.location.href = getShopifyCollectionUrl(key);
};
